import {Switch} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'

import {theme} from '../theme'

const width = 40
const height = 24

const styles = {
  root: {
    width,
    height,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    color: theme.palette.common.white,
    '&$checked': {
      transform: `translateX(${width - height}px)`,
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 'none',
      },
    },
  },
  thumb: {
    boxShadow: 'none',
    width: height - 2,
    height: height - 2,
  },
  track: {
    borderRadius: height / 2,
    backgroundColor: theme.palette.grey[100],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
}

export default withStyles(styles, {name: 'LPCSwitch'})(Switch)
